module.exports = __webpack_public_path__ + "static/media/lauren_fun.f305fe2e.png";